<i18n>
[
    "global__success"
]
</i18n>

<template>
    <BaseButton
        :id="$attrs.id"
        v-tab-focus.hasrole.hasindex="onClick"
        :isLoadingButton="true"
        :isLoading="isLoading"
        :isLoaded="isLoaded"
        :disabled="$attrs.disabled"
        :variant="variant"
        :colorVariant="colorVariant"
        :type="type"
        :labelText="labelText"
        :useSmallFont="useSmallFont"
        :isBorderless="isBorderless"
        :tabindex="isTabbable ? 0 : -1"
    >
        <template v-if="isLoading">
            <LoadingDots :isLoading="isLoading" />
        </template>

        <template v-else-if="isLoaded">
            <BaseIcon
                class="c-loading-button__icon"
                icon="global--checkmark"
                size="12px"
            />
            <slot name="loaded">
                {{ t('global__success') }}
            </slot>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </BaseButton>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { buttonProps } from '~coreModules/core/js/composables/useButton';

import BaseButton from '~coreModules/core/components/ui/buttons/BaseButton.vue';
import LoadingDots from '~coreModules/core/components/ui/LoadingDots.vue';

defineProps({
    ...buttonProps,
    type: {
        type: String,
        required: false,
        default: 'button',
    },
    labelText: {
        type: String,
        required: false,
        default: '',
    },
    isTabbable: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['click']);

const { t } = useI18n();

function onClick(e) {
    emit('click', e);
}
</script>

<style lang="scss">
    .c-loading-button {
        &__icon {
            margin-top: 2px;
        }
    }
</style>
